import "./styles/RightSideDrawer.scss";
import React, { ReactElement } from "react";
import Close from "@mui/icons-material/Close";
import { Divider } from "@mui/material";
import Drawer from "@mui/material/Drawer";

export type DrawerProps = {
    isOpen: boolean;
    onCloseClick: any;
    children: ReactElement<any, any>;
    header: string;
}

export const RightSideDrawer: React.FunctionComponent<DrawerProps> = (props) => (
    <Drawer
        open={props.isOpen}
        anchor="right"
        classes={{ paper: 'form-drawer-paper' }}>
            <Close onClick={props.onCloseClick} />
            <h2 className="drawer-header">{props.header}</h2>
            <Divider />
            <div className="drawer-body">
                {props.children}
            </div>
    </Drawer>
)

export default RightSideDrawer;